import React from "react"
import { Box, Grid } from "@mui/material"
import CommonModal from "components/CommonModal"
import AppButton from "components/StyledComponents/AppButton"
import AppTextField from "components/StyledComponents/AppTextField"
import AppSelect from "components/StyledComponents/AppSelect"
import ToggleSwitch from "components/StyledComponents/ToggleSwitch"
import { Typography } from "@mui/material"
import { unlockLogicItems } from "helpers/constant"

const TierForm = ({ open, onClose, formik, isEdit = false, loading = false }) => {
  return (
    <CommonModal
      open={open}
      onClose={onClose}
      actionButtons={
        <Box sx={{ display: "flex", justifyContent: "center", gap: 2, pb: 2 }}>
          <AppButton onClick={formik.handleSubmit} disabled={loading}>
            {loading ? "Saving..." : isEdit ? "Update" : "Save"}
          </AppButton>
        </Box>
      }
      maxWidth="md">
      <Box flexDirection="column">
        <Typography variant="h2" textAlign="center">
          {isEdit ? "Edit Tier Config" : "Add New Tier Config"}
        </Typography>
        <Grid container spacing={3} mt={2}>
          <Grid item xs={6}>
            <AppTextField
              fullWidth
              id="name"
              name="name"
              label="Tier Name"
              isRequired
              isUpperCase={true}
              placeholder="Enter Tier Name"
              value={formik.values.name}
              onChange={formik.handleChange}
              error={formik.touched.name && Boolean(formik.errors.name)}
              helperText={formik.touched.name && formik.errors.name}
            />
          </Grid>
          <Grid item xs={6}>
            <AppSelect
              id="unlock_logic"
              name="unlock_logic"
              label="Unlock Type"
              isRequired
              isUpperCase={true}
              value={formik.values.unlock_logic}
              menuItems={unlockLogicItems}
              onMenuClick={(item) => formik.setFieldValue("unlock_logic", item.value)}
              onChange={formik.handleChange}
              error={formik.touched.unlock_logic && Boolean(formik.errors.unlock_logic)}
              // helperText={formik.touched.unlock_logic && formik.errors.unlock_logic}
            />
          </Grid>

          {(formik.values.unlock_logic === "streakOnly" ||
            formik.values.unlock_logic === "coinsAndStreak") && (
            <Grid item xs={6}>
              <AppTextField
                fullWidth
                id="streak_requirement"
                name="streak_requirement"
                label="Minimum Streaks"
                type="number"
                isUpperCase={true}
                isRequired={true}
                placeholder="Enter Minimum Streaks"
                value={formik.values.streak_requirement}
                onChange={formik.handleChange}
                error={
                  formik.touched.streak_requirement && Boolean(formik.errors.streak_requirement)
                }
                helperText={formik.touched.streak_requirement && formik.errors.streak_requirement}
              />
            </Grid>
          )}
          {(formik.values.unlock_logic === "coinsOnly" ||
            formik.values.unlock_logic === "coinsAndStreak") && (
            <Grid item xs={6}>
              <AppTextField
                fullWidth
                id="coin_threshold"
                name="coin_threshold"
                label="Minimum Coins"
                type="number"
                isUpperCase={true}
                isRequired={true}
                placeholder="Enter Minimum Coins"
                value={formik.values.coin_threshold}
                onChange={formik.handleChange}
                error={formik.touched.coin_threshold && Boolean(formik.errors.coin_threshold)}
                helperText={formik.touched.coin_threshold && formik.errors.coin_threshold}
              />
            </Grid>
          )}

          <Grid item xs={6}>
            <Box sx={{ mt: 3, display: "flex", alignItems: "center", ml: 1 }}>
              <ToggleSwitch
                id="is_active"
                name="is_active"
                checked={formik.values.is_active}
                onChange={(e) => formik.setFieldValue("is_active", e.target.checked)}
              />
              <Typography variant="body2Regular" sx={{ ml: 1.5, color: "#fff" }}>
                Tier is Active
              </Typography>
            </Box>
          </Grid>
        </Grid>
      </Box>
    </CommonModal>
  )
}

export default TierForm
